import React from 'react';
import { DropZone } from '@measured/puck';

// Grid layout component
const GridComponent = ({ 
  columns = 3, 
  gap = '16px', 
  minColumnWidth = '200px',
  alignItems = 'stretch',
  justifyItems = 'stretch'
}) => {
  return (
    <DropZone
      zone="grid-zone"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(${minColumnWidth}, 1fr))`,
        gap: gap,
        alignItems: alignItems,
        justifyItems: justifyItems,
        width: '100%'
      }}
    />
  );
};

export const Grid = {
  fields: {
    columns: {
      type: 'number',
      label: 'Anzahl Spalten',
      min: 1,
      max: 6
    },
    gap: {
      type: 'select',
      label: 'Abstand zwischen Elementen',
      options: [
        { label: 'Klein (8px)', value: '8px' },
        { label: 'Mittel (16px)', value: '16px' },
        { label: 'Groß (24px)', value: '24px' },
        { label: 'Sehr groß (32px)', value: '32px' }
      ]
    },
    minColumnWidth: {
      type: 'select',
      label: 'Mindestbreite der Spalten',
      options: [
        { label: 'Schmal (150px)', value: '150px' },
        { label: 'Mittel (200px)', value: '200px' },
        { label: 'Breit (250px)', value: '250px' },
        { label: 'Sehr breit (300px)', value: '300px' }
      ]
    },
    alignItems: {
      type: 'select',
      label: 'Vertikale Ausrichtung',
      options: [
        { label: 'Strecken', value: 'stretch' },
        { label: 'Oben', value: 'start' },
        { label: 'Mitte', value: 'center' },
        { label: 'Unten', value: 'end' }
      ]
    },
    justifyItems: {
      type: 'select',
      label: 'Horizontale Ausrichtung',
      options: [
        { label: 'Strecken', value: 'stretch' },
        { label: 'Links', value: 'start' },
        { label: 'Mitte', value: 'center' },
        { label: 'Rechts', value: 'end' }
      ]
    }
  },
  render: GridComponent
};
